import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
`

export const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  line-height: 2rem;
  margin: 0 auto 1rem;
`

export const Content = styled.p`
  font-size: 0.825rem;
  line-height: 1.25rem;
  text-align: center;
  margin: 1rem auto;
`

export const CustomButton = styled.button`
  margin: 2rem auto;
  padding: 1rem 2rem;
  border: 1px solid ${({ theme }) => `rgb(${theme.primary.base})`};
  border-radius: 0.5rem;
  color: ${({ theme }) => `rgb(${theme.background.high})`};
  font-weight: 700;
  background: ${({ theme }) => `rgb(${theme.primary.base})`};
`
